exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, " \r\n.col-md-12  {\r\n    padding-left: 0px;\r\n    padding-right: 0px;\r\n}\r\n\r\n.row {\r\n    margin-left: 0px;\r\n    margin-right: 0px;\r\n}\r\n\r\n.form-control {\r\n    margin-bottom: 20px; \r\n}\r\n \r\n.btn-group {\r\n    margin-bottom: 15px;\r\n}\r\n\r\nh5 {\r\n    color: #2E2E2E;\r\n    font-weight: 600;\r\n}\r\n\r\n.save-cancel {\r\n    position: relative;\r\n    top: 17px;\r\n}\r\n\r\n.btn-cancel {\r\n    margin-right: 10px;\r\n}\r\n\r\n.temp-txt {\r\n    height: 30px;\r\n    background: white;\r\n    padding-left: 5px;\r\n    color: #9a0000;\r\n    font-size: 14px;\r\n}\r\n\r\n.container.common-bg.member-bg .slimscroll-wrapper,\r\n.container.common-bg.member-bg .slimscroll-content {\r\n    height: auto;\r\n}\r\n.ui-button, button.ui-button.ui-state-default, .ui-button.ui-state-default {\r\n    background: transparent;\r\n    border-top: 0px solid #156090;\r\n    border-right: 0px solid #156090;\r\n    border-left: 0px solid #156090;\r\n    border-bottom: 1px solid #AAAAAA;\r\n    margin-top: -1px;\r\n}\r\n\r\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/member/member-detail/member-detail.component.css
// module id = 1070
// module chunks = 0